import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import HostovaniDlouhodobaSeznam from "./HostovaniDlouhodobaSeznam";
import HostovaniDlouhodobaDetail from "./HostovaniDlouhodobaDetail";
import rootPath, { detailPath as pathDetail, RouteProps } from "./routes-path";

interface HostovaniDlouhodobaProps {
    clenId: number;
}

declare type Props = HostovaniDlouhodobaProps & RouteComponentProps<RouteProps>;

class HostovaniDlouhodoba extends React.PureComponent<Props> {
    render() {
        const { clenId } = this.props;

        return <Switch>
            <Route path={rootPath} exact render={() => <HostovaniDlouhodobaSeznam clenId={clenId} />} />
            <Route path={pathDetail} render={() => <HostovaniDlouhodobaDetail clenId={clenId} />} />

            <Redirect to={rootPath} />
        </Switch>
    }
}

export default withRouter(HostovaniDlouhodoba); 
